export const FINANCE_SIGNED_OFF = true;
export const SHOW_ZERO_PERCENT = false;
export const CALCULATOR_EMBED = true; // flip to false if I4F blocks iframing
export const I4F_CALCULATOR_URL = "https://ideal4finance.com/retail/calculator/CRS";
export const I4F_APPLY_URL = "https://ideal4finance.com/loan-apply/CRS";

export const FINANCE_CALCULATOR_PATH = "/finance-calculator";
export const FINANCE_LOAN_CALCULATOR_PATH = "/finance-loan-calculator";

/** Primary nav dropdown items for Financing. */
export const FINANCE_NAV_LINKS = [
  { label: "Payment Options", href: "/financing", external: false },
  { label: "Loan Finance", href: "/financing-i4f-how-it-works", external: false },
  { label: "Solar Lease Plan", href: "/financing-solar-lease-plan", external: false },
  { label: "Calculators", href: FINANCE_CALCULATOR_PATH, external: false },
] as const;

export const IAR_DISCLAIMER =
  "Complete Remedial Solutions (CRS) Ltd, trading as CRS Energy, is an Introducer Appointed Representative of Ideal Sales Solutions Ltd, t/a Ideal4Finance. Ideal Sales Solutions Ltd is a credit broker and not a lender (FRN 703401). Finance available subject to status. The rate offered is always provisional and will depend upon your personal circumstances, the loan amount and the term.";

export const HTG_FINANCE_DISCLOSURE =
  "Complete Remedial Solutions (CRS) Ltd, trading as CRS Energy, is an Introducer Appointed Representative of HTG Finance Limited (FRN 825534) which is authorised and regulated by the Financial Conduct Authority. The Solar Plan is a regulated consumer hire agreement, not a loan.";

export const ZERO_PERCENT_RISK_STATEMENT =
  "There are risks involved in taking out a loan or lease and you should ensure you can make all payments on time and in full; failure to do so can lead to financial difficulties and have a negative impact on your credit score.";
